import { useDrag, useDrop } from 'react-dnd';
import { useRef } from 'react';

interface DragItem {
  id: string;
  index: number;
  moveQuestion: (dragIndex: number, hoverIndex: number) => void;
}

interface InputQuestionGroupProps {
  id: string;
  index: number;
  buttonText: string;
  moveQuestion: (dragIndex: number, hoverIndex: number) => void;
  onRemove?: () => void;
  value?: string;
  onChange?: (value: string) => void;
}

const InputQuestionGroup = ({
  id,
  index,
  buttonText,
  moveQuestion,
  onRemove,
  value = '',
  onChange,
}: InputQuestionGroupProps) => {
  const dragRef = useRef<HTMLDivElement>(null);

  const [{ isDragging }, drag] = useDrag({
    type: 'question',
    item: { id, index, moveQuestion },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: 'question',
    hover: (item: DragItem) => {
      if (!dragRef.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      moveQuestion(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  drag(drop(dragRef));

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        opacity: isDragging ? 0.5 : 1,
        padding: '0.5rem',
        transform: isDragging ? 'scale(1.02)' : 'scale(1)',
        transition: 'all 0.2s ease',
        borderRadius: '4px',
        boxShadow: isDragging ? '0 5px 15px rgba(0,0,0,0.1)' : 'none',
        marginBottom: '0px',
      }}
    >
      <div
        ref={dragRef}
        style={{
          cursor: 'move',
          padding: '8px 0px',
          display: 'flex',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <img
          src="/svgs/gripvertical.svg"
          alt="Grip Vertical"
          style={{
            width: '1.2rem',
            height: '1.2rem',
            color: '#6c757d',
            paddingRight: '0.4rem',
          }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          backgroundColor: 'white',
          border: '1px solid #e4e6ef',
          borderRadius: '4px',
          overflow: 'hidden',
          width: '100%',
        }}
      >
        <div
          style={{
            padding: '8px 16px',
            backgroundColor: '#e9ecef',
            color: '#6c757d',
            minWidth: '1.5rem',
            textAlign: 'center',
          }}
        >
          {buttonText}
        </div>
        <input
          type="text"
          id={id}
          name={id}
          value={value}
          onChange={e => onChange?.(e.target.value)}
          style={{
            flex: 1,
            padding: '8px 12px',
            border: 'none',
            outline: 'none',
            fontSize: '14px',
          }}
        />
      </div>
      <img
        src="/svgs/times.svg"
        alt="X"
        style={{
          width: '1.2rem',
          height: '1.2rem',
          color: '#6c757d',
          cursor: 'pointer',
          paddingLeft: '0.4rem',
        }}
        onClick={onRemove}
        id={`remove-input-${id}`}
      />
    </div>
  );
};

export default InputQuestionGroup;
